import { render } from "./AssignAnalytesModal.vue?vue&type=template&id=e96592e8"
import script from "./AssignAnalytesModal.vue?vue&type=script&lang=js"
export * from "./AssignAnalytesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__